module.exports = __webpack_public_path__ + "media/images/work_articles_tab2_icon-3c13545dfd47bc5c4ef915ba19a33841.png";